import { useCallback, useState } from 'react'
import { toast } from 'react-toastify'

// AUTH TOKEN START
import jwt_decode from 'jwt-decode'
import { ls, formatter } from 'utils'
import { LSKEY_TOKEN } from 'constants/app'
// AUTH TOKEN END

import { eVoucherRedemptionAPI } from 'api/loyalty'
import { MerchantLookupTypes } from 'types/merchanTxTypes'
import {
  EVoucherRedemptionTxFormTypes,
  EVoucherRedemptionTxFormSubmitValuesTypes,
  EVoucherRedemptionTxFormSubmitActionsTypes,
} from 'types/eVoucherRedemptionTxTypes'
import { MemberDetail } from 'types/member'
import useMemberStore from 'store/member'

const EVOUCHERREDEMPTIONTXINITVAL: EVoucherRedemptionTxFormTypes = {
  creditValue: 0,
  externalTransactionId: 0,
  ident: '',
  storeId: 0,
  tenderDetail: [
    {
      tenderIdentifier: '',
      tenderTypeCode: '21',
      tenderValue: 0,
    },
  ],
  transactionDate: '',
  deviceCode: '',
}
export const useEVoucherRedemptionTx = (
  traderId: number,
  onCloseModal: () => void
): {
  member: MemberDetail | undefined
  isLoading: boolean
  initialValues: EVoucherRedemptionTxFormTypes
  isMerchantLookupToggle: boolean
  handleIsMerchantLookupToggle: () => void
  handleSubmitEVoucherRedemptionTx: (
    values: EVoucherRedemptionTxFormSubmitValuesTypes,
    actions: EVoucherRedemptionTxFormSubmitActionsTypes
  ) => void
  handleClearEVoucherRedemptionTx: () => void
} => {
  // AUTH TOKEN START
  const authToken = ls.get(LSKEY_TOKEN)
  const decodeAuthToken: { username: string } = jwt_decode(String(authToken))
  const authTokenUsername = decodeAuthToken?.username || ''
  // AUTH TOKEN END
  // STATES
  const [isMerchantLookupToggle, isMerchantLookupToggleSet] =
    useState<boolean>(false)
  const [isLoading, isLoadingSet] = useState<boolean>(false)
  const [purchaseTxMerchant, purchaseTxMerchantSet] = useState<
    MerchantLookupTypes[]
  >([])
  const member = useMemberStore((state) => state.member)
  const [initialValues, initialValuesSet] =
    useState<EVoucherRedemptionTxFormTypes>({
      ...EVOUCHERREDEMPTIONTXINITVAL,
      externalTransactionId: formatter.externalIdentification(),
      ident: String(member?.cardNumber) || '',
    })

  const handleIsMerchantLookupToggle = useCallback(() => {
    isMerchantLookupToggleSet(!isMerchantLookupToggle)
  }, [isMerchantLookupToggle, isMerchantLookupToggleSet])

  const handleSubmitEVoucherRedemptionTx = useCallback(
    async (
      values: EVoucherRedemptionTxFormSubmitValuesTypes,
      actions: EVoucherRedemptionTxFormSubmitActionsTypes
    ) => {
      isLoadingSet(true)
      try {
        if (String(values.externalTransactionId) === "") {
          values.externalTransactionId = initialValues.externalTransactionId + 1
        }
        await eVoucherRedemptionAPI(values)
        toast.success('E-Voucher Redemption successful.')
        // actions.setSubmitting(false)
        onCloseModal()
      } catch (error) {
        const message = JSON.parse(JSON.stringify(error))
        toast.error(`ERR: ${message.outcomeUserMessage}`)
      }
      isLoadingSet(false)
    },
    [isLoadingSet]
  )

  const handleClearEVoucherRedemptionTx = useCallback(() => {
    initialValuesSet({ ...EVOUCHERREDEMPTIONTXINITVAL })
    toast.success('Filter successfully cleared.')
  }, [initialValuesSet])

  return {
    member,
    isLoading,
    initialValues,
    isMerchantLookupToggle,
    handleIsMerchantLookupToggle,
    handleSubmitEVoucherRedemptionTx,
    handleClearEVoucherRedemptionTx,
  }
}
